import { takeLatest, call } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import * as warnOwnerApi from "../api/warnOwner";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherWarnOwner() {
  yield takeLatest(types.WARN_OWNER_REQUEST, warn);
}

function* warn(action) {
  try {
    const response = yield call(getRequest, action.id);
    response.data.message.forEach(message => {
      toastr.error(" ", message.toString());
    });
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

async function getRequest(id) {
  return warnOwnerApi.warn(id);
}
